
export const harryMediaArray = [
  {
    _id: 'harryMediaId1',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-1-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      `My "I just saw a Dementor" face`,
      `The intense look is because the only spell I know is Lumos`,
      `My "Running from a giant spider" face`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId2',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-2-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `How about I take you for a broomstick ride`,
      `Halt! Give me all your chocolate frogs!`,
      `Who's up for a memorable first date?`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId3',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Let's pretend I'm thinking something profound`,
      `Warning: wears glasses and sweaters to trick people into thinking I look smart`,
      `Let's pretend I like camping`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId4',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-4-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `I'm known for`,
      `Woke up like this`
    ],
    subcaptions: [
      `Emergency: Forgot all my charms`,
      `Overthinking everything, per usual`,
      `Last second cramming for my OWLs`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId5',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-5-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `Focusing hard on my Patronus but the only thing that's happening is Lumos`,
      `Trying very hard to look serious`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId6',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-6-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `Go on, try to find an asymmetry`,
      `My "Oculo Reparo really worked" face` 
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId7',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-7-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `My uniform`,
      `My best blue steel`
    ],
    subcaptions: [
      `My "about to play Slytherin in Quidditch" face`,
      `My "I just rode a dragon" face`,
      `Extremely concerned that I may have answered a question incorrectly on my OWL.`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId8',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-8-p.png`,
    description: ``,
    captions: [
      `Caught in the act`,
      `Me in my blogging days`,
      `I'm known for`
    ],
    subcaptions: [
      `Performing magic on my muggle cousin who has no clue`,
      `Warning: will sneak around and hide behind trees`,
      `Hidden talent: blending in with muggles`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId9',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-9-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Leave a one-word review for this`,
      `Lowkey flex`
    ],
    subcaptions: [
      `Let's assume the spell was impressive`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `Go out on a date with me or else`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId10',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-10-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Leave a one-word review for this`,
      `Lowkey flex`
    ],
    subcaptions: [
      `Let's assume the spell was impressive`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `Go out on a date with me or else`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId11',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-11-p.png`,
    description: ``,
    captions: [
      `#MondaysAmIRight?`,
      `My vulnerable side`,
      `Life outtake`
    ],
    subcaptions: [
      `My "That dragon looks angry" face`,
      `My "I just saw an elephant-sized spider" face`,
      `Did Neville just get slapped in the face by a fern?`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId12',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-12-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `Leave a one-word review for this`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      `Trying very hard to look serious`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `The world is your platform 9 and 3/4`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId13',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-13-p.png`,
    description: ``,
    captions: [
      `Dating me will look like`,
      `My weekends look like`,
      `Woke up like this`
    ],
    subcaptions: [
      `Let's assume the spell was impressive`,
      `Wanna see my Elder Wand?`,
      `Trying to make a Patronus but only Lumos is coming out`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId14',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-14-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `My uniform`,
      `My best blue steel`
    ],
    subcaptions: [
      `My "about to play Slytherin in Quidditch" face`,
      `My "I just rode a dragon" face`,
      `Extremely concerned that I may have answered a question incorrectly on my OWL.`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId15',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-15-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-15-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `Leave a one-word review for this`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      `Trying very hard to look serious`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `The world is your platform 9 and 3/4`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'harryMediaId16',
    userId: 'harryUserId',
    email: 'harry@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-16-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-16-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `Leave a one-word review for this`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `Proof that I can smile`,
      `My "Headwig is bringing me a big package" face`,
      `My "Day after a Quidditch win" face`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]